<script>
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';
  import 'vue-strap/dist/vue-strap-lang';

  export default {
    components: { Radio, checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        questionario: this.camposQuestionario(),
        auxTipoPergunta: 0,
      }
    },
    methods: {
      camposQuestionario() {
        return {
          pergunta: '',
          obrigatorio: false,
          tipoCampoResposta: false,
          tipoCampoSimNao: false,
          tipoCampoSelecao: false,
          tipoCampoSelecaoItens: '',
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            return valido;
          })
          .then(valido => {
            if (this.auxTipoPergunta === 0) {
              this.$swal(
                '',
                'É necessário informar um tipo de pergunta.',
                'info'
              );

              valido = false;

              throw new Error("validacao");
              exit;
            }

            return valido;
          })
          .then(valido => {
            if (!valido) {
              throw new Error("validacao");
            }
            else {
              this.solicitacao.solicitacaoCursoEventoForms.push(this.questionario);
              this.questionario = this.camposQuestionario();
              this.auxTipoPergunta = 0;
              this.$validator.reset();
            }
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      deletarQuestionario(indice) {
        this.solicitacao.solicitacaoCursoEventoForms.splice(indice, 1);
      },
      setTipoPergunta() {
        this.questionario.tipoCampoSimNao = false;
        this.questionario.tipoCampoResposta = false;
        this.questionario.tipoCampoSelecao = false;

        switch (this.auxTipoPergunta) {
          case '1':
            this.questionario.tipoCampoResposta = true;
            this.questionario.tipoCampoSelecaoItens = '';
            break;
          case '2':
            this.questionario.tipoCampoSimNao = true;
            this.questionario.tipoCampoSelecaoItens = '';
            break;
          case '3':
            this.questionario.tipoCampoSelecao = true;
            break;
        }
      },
      textotipoPergunta(questionario) {
        if (questionario.tipoCampoResposta)
          return 'Campo Resposta';

        if (questionario.tipoCampoSimNao)
          return 'Campo Sim/Não';

        if (questionario.tipoCampoSelecao)
          return 'Campo Seleção';
      },   
      textoItens(questionario) {
        if (questionario.tipoCampoSelecaoItens)
            return questionario.tipoCampoSelecaoItens.replace(/\r\n/g, '</br>').replace(/\n/g, '</br>');

        return '';
      }
    },
    mounted() {

    },
    watch: {
      'auxTipoPergunta': 'setTipoPergunta'
    }
  }
</script>

<template>
  <div>
    <div class="ibox-footer">
      <div class="table-responsive">
        <table class="table table-bordered table-column-code table-column-action">
          <thead v-if="solicitacao.solicitacaoCursoEventoForms.length > 0">
            <tr>
              <th></th>
              <th>Pergunta</th>
              <th>Tipo de pergunta</th>
              <th>Obrigatória</th>
              <th>Itens da seleção</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="solicitacao.solicitacaoCursoEventoForms.length > 0">
            <tr v-for="(questionario, index) in solicitacao.solicitacaoCursoEventoForms">
              <td></td>
              <td>{{ questionario.pergunta }}</td>
              <td>{{ textotipoPergunta(questionario) }}</td>
              <td>{{ questionario.obrigatorio == '1' ? 'Sim' : 'Não' }}</td>
              <td><span v-if="questionario.tipoCampoSelecao" v-html="textoItens(questionario)" /></td>
              <td>
                <div class="form-group no-margins">
                  <button type="button"
                          class="btn btn-sm btn-danger btn-delete-item"
                          title="Excluir item"
                          @click="deletarQuestionario(index)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="solicitacao.solicitacaoCursoEventoForms.length === 0">
            <tr>
              <td class="text-center">Nenhuma pergunta encontrada.</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="form-group required col-xs-6" :class="{'has-error': errors.has('pergunta')}">
        <label class="control-label" for="pergunta">Pergunta</label>

        <input type="text"
               class="form-control"
               id="pergunta"
               v-model="questionario.pergunta"
               data-vv-name="pergunta"
               data-vv-as="pergunta"
               v-validate="'required'">

        <p class="text-danger" v-show="errors.has('pergunta')">{{ errors.first('pergunta') }}</p>
      </div>

      <div class="form-group col-xs-1">
        <div class="checkbox" style="padding-top: 12px">
          <checkbox v-model="questionario.obrigatorio" value="1" type="primary">
            Pergunta obrigatória
          </checkbox>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group required" :class="{'has-error': errors.has('tipo')}">
          <label class="control-label block">Tipo de pergunta</label>

          <radio v-model="auxTipoPergunta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Campo Resposta
          </radio>
          <radio v-model="auxTipoPergunta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Campo Sim/Não
          </radio>
          <radio v-model="auxTipoPergunta"
                 selected-value="3"
                 type="success"
                 :inline="true">
            Campo Seleção
          </radio>
          <p class="text-danger" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</p>
        </div>
      </div>      
    </div>

    <div class="row" v-if="auxTipoPergunta == 3">
      <div class="form-group required col-xs-12"  :class="{'has-error': errors.has('tipoCampoSelecaoItens')}">
        <label class="control-label" for="tipoCampoSelecaoItens">Informe abaixo os itens da seleção, coloque um item por linha</label>

        <textarea class="form-control "
                  id="tipoCampoSelecaoItens"
                  v-model="questionario.tipoCampoSelecaoItens"
                  data-vv-name="tipoCampoSelecaoItens"
                  data-vv-as="itens da seleção"
                  v-validate="'required'">
        </textarea>

        <p class="text-danger" v-show="errors.has('tipoCampoSelecaoItens')">{{ errors.first('tipoCampoSelecaoItens') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar pergunta
          </button>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormQuestionario.vue